import { Card, Rating, Stack, Typography } from "@mui/material";
import StarRoundedIcon from "@mui/icons-material/StarRounded";

interface IProps {
  score: number | null;
  setScore?(score: number | null): void;
  readonly?: boolean;
  size?: "small" | "medium" | "large";
  onClick?: () => void;
}

export default function Score({ score, setScore, readonly, size, onClick }: IProps) {
  return (
    <Card
      sx={{
        px: size === "small" ? 1 : 2,
        py: size === "small" ? 0.5 : 1,
        borderRadius: "10px",
        cursor: onClick ? "pointer" : "",
      }}
      onClick={onClick && onClick}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        {readonly && (
          <Typography variant={size === "small" ? "h6" : "h5"} sx={{ color: "#FFF500", fontFamily: "sans-serif" }}>
            {score || 0}
          </Typography>
        )}
        <Rating
          name="half-rating"
          precision={0.5}
          icon={<StarRoundedIcon fontSize={size || "large"} />}
          emptyIcon={<StarRoundedIcon fontSize={size || "large"} />}
          value={score}
          onChange={(e, value) => setScore && setScore(value)}
          readOnly={readonly}
          sx={{
            "& .MuiRating-iconFilled": {
              color: "#BDFF00",
            },
            "& .MuiRating-iconHover": {
              color: "#BDFF00",
            },
          }}
        />
      </Stack>
    </Card>
  );
}
